import { useEffect, useState } from 'react';
import { api } from '../../services/api';

const API_URL = import.meta.env.VITE_API_URL || '/api';

/**
 * Le immagini stanno dietro un endpoint autenticato, quindi un <img src> semplice
 * non funziona: il browser non manderebbe il token. Scarichiamo il blob e ne
 * teniamo l'object URL finché il componente vive.
 *
 * La cache è a livello di modulo: la stessa foto aperta e richiusa dieci volte
 * si scarica una volta sola.
 */
const cache = new Map<string, string>();

export function FotoProtetta({
  documentoId,
  alt,
  className,
  onClick,
}: {
  documentoId: string;
  alt: string;
  className?: string;
  onClick?: () => void;
}) {
  const [url, setUrl] = useState<string | null>(cache.get(documentoId) ?? null);
  const [errore, setErrore] = useState(false);

  useEffect(() => {
    if (cache.has(documentoId)) {
      setUrl(cache.get(documentoId)!);
      return;
    }
    let annullato = false;

    (async () => {
      try {
        const token = api.getAccessToken();
        const res = await fetch(`${API_URL}/documenti/${documentoId}/download`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) throw new Error('immagine non recuperata');
        const blob = await res.blob();
        if (annullato) return;
        const objectUrl = URL.createObjectURL(blob);
        cache.set(documentoId, objectUrl);
        setUrl(objectUrl);
      } catch {
        if (!annullato) setErrore(true);
      }
    })();

    return () => {
      annullato = true;
    };
  }, [documentoId]);

  if (errore) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 text-gray-400 text-xs ${className ?? ''}`}>
        non caricata
      </div>
    );
  }

  if (!url) {
    return <div className={`animate-pulse bg-gray-200 ${className ?? ''}`} />;
  }

  return <img src={url} alt={alt} className={className} onClick={onClick} loading="lazy" />;
}
